module.exports = __webpack_public_path__ + "static/media/pink-template-small.c188dfc3.png";